module.exports = __webpack_public_path__ + "img/营业资讯精准掌握@2x.ee547b4b.png";